import { getApiErrorMessage } from '../../utils/apiError';

/**
 * Backend `code` (backend/src/services/factoryService.js) and the Polish
 * express-validator messages of routes/factories.js → `factories:` keys.
 */
export const FACTORY_ERROR_MESSAGE_MAP: Record<string, string> = {
  FACTORY_NAME_DUPLICATE: 'factories:messages.duplicateName',
  FACTORY_NOT_FOUND: 'factories:messages.notFound',
  FACTORY_IN_USE: 'factories:messages.inUse',
  FACTORY_NAME_REQUIRED: 'factories:messages.nameRequired',
  'Podaj nazwę fabryki': 'factories:messages.nameRequired',
  'Podaj poprawny adres e-mail': 'factories:messages.emailInvalid',
};

export function getFactoryErrorCode(error: any): string | undefined {
  const code = error?.response?.data?.code;
  return typeof code === 'string' ? code : undefined;
}

export function getFactoryErrorMessage(
  error: any,
  t: any,
  fallbackKey: string,
  params: Record<string, unknown> = {},
): string {
  const code = getFactoryErrorCode(error);
  if (code && FACTORY_ERROR_MESSAGE_MAP[code]) {
    return t(FACTORY_ERROR_MESSAGE_MAP[code], params);
  }
  return getApiErrorMessage(error, t, fallbackKey, FACTORY_ERROR_MESSAGE_MAP, params);
}
